<form nz-form nzLayout="vertical" [formGroup]="createUserForm">
  <nz-row nzGutter="16">
    <nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="firstName" class="nfl-form-label">First Name</nz-form-label>
        <nz-form-control [nzErrorTip]="firstNameErrorTemplate">
          <input
            nz-input
            formControlName="firstName"
            id="firstName"
            placeholder="First Name"
            appTrimFormInput
            maxlength="50"
          />
        </nz-form-control>
      </nz-form-item>
      <ng-template #firstNameErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the first name</div>
        <div *ngIf="control?.errors?.['minlength']">
          First name must be at least
          {{ control?.errors?.['minlength'].requiredLength }} characters long.
        </div>
        <div *ngIf="control?.errors?.['maxlength']">
          First name cannot exceed
          {{ control?.errors?.['maxlength'].requiredLength }} characters.
        </div>
        <div *ngIf="control?.errors?.['pattern']">First name should only contain alphabetic characters.</div>
      </ng-template>
    </nz-col>

    <nz-col nzSpan="12">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="lastName" class="nfl-form-label">Last Name</nz-form-label>
        <nz-form-control [nzErrorTip]="lastNameErrorTemplate">
          <input
            nz-input
            formControlName="lastName"
            id="lastName"
            placeholder="Last Name"
            appTrimFormInput
            maxlength="50"
          />
        </nz-form-control>
      </nz-form-item>
      <ng-template #lastNameErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the last name</div>
        <div *ngIf="control?.errors?.['minlength']">
          Last name must be at least
          {{ control?.errors?.['minlength'].requiredLength }} characters long.
        </div>
        <div *ngIf="control?.errors?.['maxlength']">
          Last name cannot exceed
          {{ control?.errors?.['maxlength'].requiredLength }} characters.
        </div>
        <div *ngIf="control?.errors?.['pattern']">Last name should only contain alphabetic characters.</div>
      </ng-template>
    </nz-col>
  </nz-row>

  <nz-row nzGutter="16">
    <nz-col [nzSpan]="isNFLAdmin ? 12 : 24">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="email" class="nfl-form-label">Email</nz-form-label>
        <nz-form-control [nzErrorTip]="emailErrorTemplate">
          <input nz-input formControlName="email" id="email" placeholder="Email" appTrimFormInput maxlength="100" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #emailErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the email</div>
        <div *ngIf="control?.errors?.['pattern']">Please enter a valid email</div>
        <div *ngIf="control?.errors?.['maxlength']">
          Email cannot exceed
          {{ control?.errors?.['maxlength'].requiredLength }} characters.
        </div>
      </ng-template>
    </nz-col>

    <nz-col nzSpan="12" *ngIf="isNFLAdmin">
      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="orgName" class="nfl-form-label">Organization</nz-form-label>
        <nz-form-control [nzErrorTip]="orgNameErrorTemplate">
          <input
            nz-input
            formControlName="orgName"
            id="orgName"
            placeholder="Organization"
            appTrimFormInput
            maxlength="40"
          />
        </nz-form-control>
      </nz-form-item>
      <ng-template #orgNameErrorTemplate let-control>
        <div *ngIf="control?.errors?.['required']">Please enter the organization</div>
        <div *ngIf="control?.errors?.['minlength']">
          Organization must be at least
          {{ control?.errors?.['minlength'].requiredLength }} characters long.
        </div>
        <div *ngIf="control?.errors?.['maxlength']">
          Organization cannot exceed
          {{ control?.errors?.['maxlength'].requiredLength }} characters.
        </div>
        <div *ngIf="control?.errors?.['pattern']">
          Organization name should start with alphabet, and it can be alphanumeric and no special characters are allowed
        </div>
      </ng-template>
    </nz-col>
  </nz-row>

  <nz-form-item>
    <nz-form-label [nzRequired]="true" nzFor="role" class="nfl-form-label">Role</nz-form-label>
    <nz-form-control nzErrorTip="Role is required">
      <nz-select nzPlaceHolder="Select a Role" formControlName="role" id="role" nzShowSearch [nzLoading]="isLoading">
        <nz-option [nzLabel]="role.name" [nzValue]="role.value" *ngFor="let role of roleOptions"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item *ngIf="isNFLAdmin">
    <nz-form-label [nzRequired]="true" nzFor="orgType" class="nfl-form-label">Organization Type</nz-form-label>
    <nz-form-control nzErrorTip="Organization type is required">
      <nz-select
        nzPlaceHolder="Select a Organization Type"
        formControlName="orgType"
        id="orgType"
        nzShowSearch
        [nzLoading]="isLoading"
      >
        <nz-option
          [nzLabel]="orgType.name"
          [nzValue]="orgType.value"
          *ngFor="let orgType of orgTypeOptions"
        ></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item *ngIf="isNFLAdmin">
    <nz-form-control>
      <label nz-checkbox formControlName="userWillExportViaSFTP"> User will export data via SFTP </label>
    </nz-form-control>
    <nz-form-control>
      <label nz-checkbox formControlName="userWillExportViaDatabricks"> User will export data via Databricks </label>
    </nz-form-control>
  </nz-form-item>

  <nz-col nzSpan="24" *ngIf="isNFLAdmin && userWillExportViaSFTPControl.value === true">
    <p nz-typography class="nfl-form-label mb0">S3 Bucket Name</p>
    <p nz-typography>{{ bucketName }}</p>
  </nz-col>
  <ng-template #bucketNameErrorTemplate let-control>
    <div *ngIf="control?.errors?.['required']">Please enter the S3 bucket name</div>
    <div *ngIf="control?.errors?.['pattern']">
      S3 bucket name must not contain spaces and should follow AWS naming conventions Example: dcr-{{ ENV }}-abcd1234
    </div>
    <div *ngIf="control?.errors?.['maxlength']">
      S3 bucket name cannot exceed
      {{ control?.errors?.['maxlength'].requiredLength }} characters.
    </div>
  </ng-template>

  <div nz-row>
    <nz-form-item class="w100 button-row">
      <nz-space nzSize="middle">
        <button *nzSpaceItem nz-button nzType="default" (click)="handleCancel()">Cancel</button>
        <button
          *nzSpaceItem
          nz-button
          nzType="primary"
          [nzLoading]="isLoading"
          [disabled]="createUserForm.invalid || !isValidOrgType"
          (click)="userData ? handleUpdateUser() : handleCreateUser()"
        >
          {{ userData ? 'Update User' : 'Create User' }}
        </button>
      </nz-space>
    </nz-form-item>
  </div>
</form>
